import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
// import Lenis from "@studio-freight/lenis";
import Header from "./components/header";
import Footer from "./components/footer";
import Home from "./components/home/home";
import Contactus from "./components/contactPage/immigration-office-australia-consultants";
import Navbar from "./components/navbar";
import AboutUs from "./components/aboutPage/best-migration-australia-consultants";
import SkillIndependentVisa from "./components/skill-independent-visa/subclass-189-visa-australia-consultants";
import SkillNominatedVisa from "./components/skill-nominated-visa/subclass-190-visa-australia-consultants";
import SkillWorkReligion from "./components/skill-worked-religion/subclass-491-visa-australia-consultants";
import StudentVisa from "./components/student-visa/subclass-500-student-visa-australia-consultants";
import StudentGuardianVisa from "./components/student-guardian-visa/student-guardian-visa";
import SkillAssesment from "./components/skill-assesment/skill-assessment-australia-consultants";
import ParentVisa from "./components/parent-visa/subclass-143-parent-visa-australia-consultants";
import FamilyVisa from "./components/family-visa/family-sponsorship-visa-australia-consultants";
import VisitorVisa from "./components/visitor-visa/australia-visitor-visa-consultants";
import PartnerVisa from "./components/partner-visa/partner-visa-australia";
import EmployeeTrainingVisa from "./components/employee-training-visa/subclass-407-visa-australia-consultants";
import EmployeeSkilledReligion from "./components/employee-skilled-religion/subclass-494-visa-australia-consultants";
import EmployeeTemporaryVisa from "./components/employee-temporary-visa/subclass-400-visa-australia-consultants";
import TemporaryGraduateVisa from "./components/temporary-graduate-visa/subclass-485-visa-australia-consultants";
import EmployeeReligionMigration from "./components/employee-religion-migration/subclass-187-visa-australia-consultants";
import EmployeeTemporarySkilledVisa from "./components/employee-temporary-skilled-vis/skills-in-demand-visa-482-australia-consultants";
import EmployerSponserVisa from "./components/employee-sponser-nominated-visa/employee-sponser";
import EmployeeNominatedSchemaVisa from "./components/employee-nominated-schema-visa/subclass-186-visa-australia-consultants";
import BenyPartnership from "./components/employee-partnership/beny-for-employers";
import BenyMigration from "./components/employee-partnership/beny-migration";
import PermanentResidenceRegional191 from "./components/permanent-residence-regional-191/subclass-191-visa-australia-consultants";
import ProspectiveMarriageVisa300 from "./components/prospective-marriage-visa-300/subclass-300-visa-australia-consultants";
import AustralianRelativesVisa from "./components/relatives-visa/australian-relatives-visa-consultants";
import ResidentReturnVisa from "./components/resident-return-visa/subclass-155-157-visa-australia-consultants";
import SkillsInDemandVisa482 from "./components/skills-in-demand-visa-482/subclass-482-visa-australia-consultants";
import TradeCourses from "./components/trade-courses/trade-courses-australia-consultants";
import VisaCancellations from "./components/visa-cancellations/visa-cancellations-australia-consultants";
import VisaRefusalAppeal from "./components/visa-refusal-appeal/visa-refusal-appeal-australia-consultants";
import WorkingHolidayVisa from "./components/working-holiday-visa/working-holiday-visa-australia-consultants";
import AATReview from "./components/aat-review/aat-review-australia-consultants";
import ChildVisa from "./components/child-visa/child-visa-australia-consultants";
import Citizenship from "./components/citizenship/citizenship-australia-consultants";
import News from "./components/news/news-immigration-australia";
import MigrationProgram202425 from "./components/news/migration-program-2024-25";
import EmployerSponsoredVisas202425 from "./components/news/employer-sponsored-visas-2024-25";
import InternationalStudentVisaProcessing2024 from "./components/news/international-student-visa-processing-2024";
import CoalitionMigrationPolicyProposal from "./components/news/coalition-migration-policy-proposal";
import NetMigrationForecasts202627 from "./components/news/net-migration-forecasts-2026-27";
import ImmigrationStrategyVisionFuture from "./components/news/immigration-strategy-vision-future";
import NZAustraliaVisa from "./components/nz-to-australia-visa/nz-australia-visa-consultants";
import NotFound from "./components/NotFound";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import ThankYou from "./components/ThankYou";
import Resources from "./components/resources/Resources";
// import watsappicon from "../src/images/home/watsapp-icon.png";

// Smooth Scroll Component
function SmoothScroll({ children }) {
  const lenisRef = useRef();
  const location = useLocation();

  // useEffect(() => {
  //   // Initialize Lenis smooth scroll
  //   // lenisRef.current = new Lenis({
  //   //   duration: 1.2,
  //   //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  //   //   direction: "vertical",
  //   //   gestureDirection: "vertical",
  //   //   smooth: false,
  //   //   mouseMultiplier: 1,
  //   //   smoothTouch: false,
  //   //   touchMultiplier: 2,
  //   //   infinite: false,
  //   // });

  //   // RAF animation function for Lenis
  //   function raf(time) {
  //     lenisRef.current.raf(time);
  //     requestAnimationFrame(raf);
  //   }

  //   requestAnimationFrame(raf);

  //   return () => {
  //     // Clean up Lenis instance on component unmount
  //     lenisRef.current.destroy();
  //   };
  // }, []);

  // Reset scroll position when route changes
  useEffect(() => {
    window.scrollTo(0, 0);

    // Optional: You can add a small delay before re-enabling smooth scrolling after navigation
    lenisRef.current?.stop();
    setTimeout(() => {
      lenisRef.current?.start();
    }, 100);
  }, [location.pathname]);

  return children;
}

function App() {
  const [showFloatingWidgets, setShowFloatingWidgets] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);

    // Handle scroll to show/hide floating widgets on mobile
    const handleScroll = () => {
      if (isMobile) {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        // Show widgets after scrolling past 50% of the second section (approximately 150vh)
        setShowFloatingWidgets(scrollY > windowHeight * 1.5);
      } else {
        // Always show on desktop
        setShowFloatingWidgets(true);
      }
    };

    handleScroll(); // Initial check
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);

  // Hide/show Tawk.to widget based on scroll state
  useEffect(() => {
    const handleTawkWidget = () => {
      if (typeof window !== 'undefined' && window.Tawk_API && typeof window.Tawk_API.showWidget === 'function') {
        if (isMobile) {
          if (showFloatingWidgets) {
            window.Tawk_API.showWidget();
          } else {
            window.Tawk_API.hideWidget();
          }
        } else {
          window.Tawk_API.showWidget();
        }
      }
    };

    // Check if Tawk_API is already loaded
    if (window.Tawk_API) {
      handleTawkWidget();
    } else {
      // Wait for Tawk_API to load
      const checkTawkReady = setInterval(() => {
        if (window.Tawk_API && typeof window.Tawk_API.showWidget === 'function') {
          handleTawkWidget();
          clearInterval(checkTawkReady);
        }
      }, 100);

      // Clear interval after 10 seconds if Tawk doesn't load
      setTimeout(() => {
        clearInterval(checkTawkReady);
      }, 10000);
    }
  }, [showFloatingWidgets, isMobile]);

  return (
    <BrowserRouter basename="/">
      <SmoothScroll>
        <div className="App">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <Home />
                  <Footer />
                </>
              }
            />
            <Route
              path="/best-migration-australia-consultants"
              element={
                <>
                  <Navbar />
                  <AboutUs />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-189-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <SkillIndependentVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-190-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <SkillNominatedVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-491-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <SkillWorkReligion />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-500-student-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <StudentVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/student-guardian-visa"
              element={
                <>
                  <Navbar />
                  <StudentGuardianVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/skill-assessment-australia-consultants"
              element={
                <>
                  <Navbar />
                  <SkillAssesment />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-143-parent-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <ParentVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/family-sponsorship-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <FamilyVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/partner-visa-australia"
              element={
                <>
                  <Navbar />
                  <PartnerVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/australia-visitor-visa-consultants"
              element={
                <>
                  <Navbar />
                  <VisitorVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-407-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <EmployeeTrainingVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-494-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <EmployeeSkilledReligion />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-400-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <EmployeeTemporaryVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-485-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <TemporaryGraduateVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-187-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <EmployeeReligionMigration />
                  <Footer />
                </>
              }
            />
            <Route
              path="/skills-in-demand-visa-482-australia-consultants"
              element={
                <>
                  <Navbar />
                  <EmployeeTemporarySkilledVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/employee-sponser-visa"
              element={
                <>
                  <Navbar />
                  <EmployerSponserVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/subclass-186-visa-australia-consultants"
              element={
                <>
                  <Navbar />
                  <EmployeeNominatedSchemaVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/beny-for-employers"
              element={
                <>
                  <BenyPartnership />
                  <Footer />
                </>
              }
            />
            <Route
              path="/immigration-office-australia-consultants"
              element={
                <>
                  <Navbar />
                  <Contactus />
                  <Footer />
                </>
              }
            />
            <Route
              path="/beny-migration"
              element={
                <>
                  <BenyMigration />
                  <Footer />
                </>
              }
            />
            <Route
              path="/privacy-policy"
              element={<PrivacyPolicy />}
            />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route
              path="/thank-you"
              element={<ThankYou />}
            />
            <Route
              path="/contact-us"
              element={
                <>
                  <Navbar />
                  <Contactus />
                  <Footer />
                </>
              }
            />
            {/* Placeholder routes for new navigation items */}
            <Route
              path="/skills-in-demand-visa-482"
              element={
                <>
                  <Navbar />
                  <SkillsInDemandVisa482 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/working-holiday-visa"
              element={
                <>
                  <Navbar />
                  <WorkingHolidayVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/permanent-residence-regional-191"
              element={
                <>
                  <Navbar />
                  <PermanentResidenceRegional191 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/prospective-marriage-visa-300"
              element={
                <>
                  <Navbar />
                  <ProspectiveMarriageVisa300 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/child-visa"
              element={
                <>
                  <Navbar />
                  <ChildVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/relatives-visa"
              element={
                <>
                  <Navbar />
                  <AustralianRelativesVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/new-zealand-to-au"
              element={
                <>
                  <Navbar />
                  <NZAustraliaVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/resident-return-visa"
              element={
                <>
                  <Navbar />
                  <ResidentReturnVisa />
                  <Footer />
                </>
              }
            />
            <Route
              path="/citizenship"
              element={
                <>
                  <Navbar />
                  <Citizenship />
                  <Footer />
                </>
              }
            />
            <Route
              path="/trade-courses"
              element={
                <>
                  <Navbar />
                  <TradeCourses />
                  <Footer />
                </>
              }
            />
            <Route
              path="/visa-refusal-appeal"
              element={
                <>
                  <Navbar />
                  <VisaRefusalAppeal />
                  <Footer />
                </>
              }
            />
            <Route
              path="/aat-review"
              element={
                <>
                  <Navbar />
                  <AATReview />
                  <Footer />
                </>
              }
            />
            <Route
              path="/visa-cancellations"
              element={
                <>
                  <Navbar />
                  <VisaCancellations />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news"
              element={
                <>
                  <Navbar />
                  <News />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news/migration-program-2024-25"
              element={
                <>
                  <Navbar />
                  <MigrationProgram202425 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news/employer-sponsored-visas-2024-25"
              element={
                <>
                  <Navbar />
                  <EmployerSponsoredVisas202425 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news/international-student-visa-processing-2024"
              element={
                <>
                  <Navbar />
                  <InternationalStudentVisaProcessing2024 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news/coalition-migration-policy-proposal"
              element={
                <>
                  <Navbar />
                  <CoalitionMigrationPolicyProposal />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news/net-migration-forecasts-2026-27"
              element={
                <>
                  <Navbar />
                  <NetMigrationForecasts202627 />
                  <Footer />
                </>
              }
            />
            <Route
              path="/news/immigration-strategy-vision-future"
              element={
                <>
                  <Navbar />
                  <ImmigrationStrategyVisionFuture />
                  <Footer />
                </>
              }
            />
            <Route
              path="/resources"
              element={
                <>
                  <Navbar />
                  <Resources />
                  <Footer />
                </>
              }
            />
            {/* Catch-all route for 404 page - must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
